const UID_STORAGE_KEY = "upme.by.uid";

const GUID_REGEX =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isValidGuid = (value) =>
    typeof value === "string" && GUID_REGEX.test(value.trim());

const generateUid = () => {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }

    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
        const random = Math.random() * 16 | 0;
        const value = char === "x" ? random : (random & 0x3 | 0x8);
        return value.toString(16);
    });
};

const readStoredUid = () => localStorage.getItem(UID_STORAGE_KEY)?.trim() || null;

const replaceStoredUid = (customerId) => {
    const nextKey = typeof customerId === "string"
        ? customerId.trim()
        : String(customerId ?? "").trim();
    if (!nextKey) {
        return;
    }

    const currentKey = readStoredUid();
    if (currentKey === nextKey) {
        return;
    }

    localStorage.removeItem(UID_STORAGE_KEY);
    localStorage.setItem(UID_STORAGE_KEY, nextKey);
};

/** Replace `upme.by.uid` with stable `customerId` from backend response. */
export const syncCustomerIdToStoredUid = (customerId) => {
    replaceStoredUid(customerId);
};

/** @deprecated use syncCustomerIdToStoredUid */
export const syncAnonymousKeyFromCustomerId = syncCustomerIdToStoredUid;

/** @deprecated use syncCustomerIdToStoredUid */
export const syncStoredUidFromCustomerId = syncCustomerIdToStoredUid;

export const getUid = () => {
    const storedUid = readStoredUid();
    if (storedUid) {
        return storedUid;
    }

    const uid = generateUid();
    localStorage.setItem(UID_STORAGE_KEY, uid);

    return uid;
};

export const getOrCreateAnonymousUid = getUid;

export const isUnauthorizedUser = () => {
    try {
        const raw = localStorage.getItem("profile");
        if (!raw || raw === "null") {
            return true;
        }
        const profile = JSON.parse(raw);
        return !profile || profile.userName === "AnonymousUser";
    } catch {
        return true;
    }
};

export const initAnonymousUid = () => {
    getUid();
};
